import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_ROOT = `${BASE}/api`;

export const api = axios.create({ baseURL: API_ROOT, withCredentials: true });

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

// Double-submit CSRF: attach the csrf_token cookie value as a header on mutating requests.
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    const csrf = getCookie("csrf_token");
    if (csrf) config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});

// Transparent access-token refresh on 401 (once), except for auth endpoints.
let refreshing: Promise<any> | null = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const url: string = original.url || "";
    const isAuthPath = url.includes("/auth/");
    if (error.response?.status === 401 && !original._retried && !isAuthPath) {
      original._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e: any): string {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
